import { UserAgentApplication } from 'msal';
import { authenticatingUserSuccess } from 'redux/actions/auth';
import store from 'redux/store';
import config from 'config';

export const isIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ') > -1;
    const msie11 = ua.indexOf('Trident/') > -1;

    return msie || msie11;
};

export const authAgent = new UserAgentApplication({
    auth: {
        clientId: config.auth.clientId,
        authority: config.auth.authority,
        redirectUri: config.auth.redirectUri,
        postLogoutRedirectUri: window.location.origin,
        validateAuthority: true,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE(),
    },
});

authAgent.handleRedirectCallback((error, response) => {
    if (error) {
        console.warn('An error occurred acquiring a token with redirect');
        console.warn(error);

        getAccessTokenPopup(authAgent)
            .then((popupResponse) => {
                store.dispatch(
                    authenticatingUserSuccess(popupResponse.accessToken, popupResponse.expiresOn, popupResponse.account.name, popupResponse.account.userName)
                );
            })
            .catch((error) => {
                console.warn('Error occurred acquiring token with popup');
                console.warn(error);
            });
    }

    if ('tokenType' in response && response.tokenType === 'access_token') {
        store.dispatch(authenticatingUserSuccess(response.accessToken, response.expiresOn, response.account.name, response.account.userName));
    }
});

export const requiresInteraction = (errorMessage) => {
    if (!errorMessage || !errorMessage.length) {
        return false;
    }

    return errorMessage.indexOf('consent_required') > -1 || errorMessage.indexOf('interaction_required') > -1 || errorMessage.indexOf('login_required') > -1;
};

export const loginUserWithRedirect = () => {
    if (window.location.pathname) {
        localStorage.setItem('previousUrl', window.location.pathname);
    }
    authAgent.loginRedirect({
        scopes: config.auth.scopes,
        redirectUri: config.auth.redirectUri,
    });
};

export const loginUserWithSSO = async () => {
    await authAgent.ssoSilent({
        scopes: config.auth.scopes,
        redirectUri: config.auth.redirectUri,
        extraQueryParameters: { domain_hint: 'EMCloudAD.onmicrosoft.com' },
    });
};

export const getAccessTokenSilent = async () => {
    return await authAgent.acquireTokenSilent({
        scopes: config.auth.scopes,
    });
};

export const getAccessTokenPopup = async () => {
    return await authAgent.acquireTokenPopup({
        scopes: config.auth.scopes,
        redirectUri: config.auth.redirectUri,
    });
};

export const getAccessTokenInteractive = () => {
    return authAgent.acquireTokenRedirect({
        scopes: config.auth.scopes,
        redirectUri: config.auth.redirectUri,
    });
};

export const logout = () => {
    authAgent.logout();
    localStorage.removeItem('previousUrl');
};
